// extracted by mini-css-extract-plugin
export default {"breakpoint-sm":"576px","breakpoint-md":"768px","breakpoint-lg":"992px","breakpoint-xl":"1200px","breakpoint-xxl":"1320px","green":"#1abf67"};